import React from "react";
import { Trash2, Download } from "lucide-react";
import { CustomMemeTemplate } from "../../types";
import OptimizedImage from "../OptimizedImage";

interface TemplatesGridProps {
  templates: CustomMemeTemplate[];
  onDeleteTemplate: (id: string) => void;
  onDownloadTemplate: (imageUrl: string, filename: string) => void;
}

const TemplatesGrid: React.FC<TemplatesGridProps> = ({
  templates,
  onDeleteTemplate,
  onDownloadTemplate,
}) => {
  if (templates.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-500 text-lg mb-2" dir="rtl">
          אין תבניות מותאמות אישית
        </div>
        <p className="text-gray-400" dir="rtl">
          הוסף תבנית חדשה כדי להתחיל
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {templates.map((template) => (
        <div
          key={template.id}
          className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
        >
          <div className="aspect-square bg-gray-100">
            <OptimizedImage
              src={template.image_url}
              thumbnailSrc={template.thumbnail_url}
              alt={template.name}
              className="w-full h-full object-cover object-center"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="p-4">
            <h3 className="font-semibold text-gray-900 mb-2" dir="rtl">
              {template.name}
            </h3>
            <p className="text-sm text-gray-500 mb-4" dir="rtl">
              קטגוריה: {template.category}
            </p>
            <div className="flex space-x-2">
              <button
                onClick={() =>
                  onDownloadTemplate(template.image_url, `${template.name}.jpg`)
                }
                className="flex-1 px-3 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center justify-center space-x-1"
                dir="rtl"
              >
                <Download className="h-4 w-4" />
                <span>הורד</span>
              </button>
              <button
                onClick={() => onDeleteTemplate(template.id)}
                className="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TemplatesGrid;
